import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthorizationService } from '../services/authorization.service';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class RoleAuthGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthorizationService) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | Observable<boolean> | Promise<boolean> {
        const accessData = route.routeConfig?.data as any;

        if (!accessData || !accessData.accessDetail) {
            this.router.navigate(['noaccess']);
            return false;
        }

        if (this.authService.permissions) {
            return this.checkAccess(accessData.accessDetail);
        }

        // Handle async permissions check
        return new Promise<boolean>((resolve) => {
            setTimeout(() => {
                resolve(this.checkAccess(accessData.accessDetail));
            }, 2000);
        });
    }

    private async checkAccess(accessDetail: any): Promise<boolean> {
        const hasAccess = await this.authService.checkAccess(accessDetail); // Assume checkAccess returns Promise<boolean>
        if (!hasAccess) {
            this.router.navigate(['noaccess']);
            return false;
        }
        return true;
    }
}